import { useEffect, useState } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "./ui/alert-dialog";

// Promise-based Equiro confirm — replaces native window.confirm across the app.
let _open = null;
export function confirmAction(opts) {
  return new Promise((resolve) => { if (_open) _open(opts, resolve); else resolve(window.confirm(opts?.description || "Confermi?")); });
}

export function ConfirmHost() {
  const [st, setSt] = useState(null);
  useEffect(() => { _open = (opts, res) => setSt({ ...opts, res }); return () => { _open = null; }; }, []);
  if (!st) return null;
  const done = (v) => { st.res(v); setSt(null); };
  return (
    <AlertDialog open onOpenChange={(o) => !o && done(false)}>
      <AlertDialogContent data-testid="confirm-dialog" onOpenAutoFocus={(e) => e.preventDefault()}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">{st.title || "Confermi l'operazione?"}</AlertDialogTitle>
          <AlertDialogDescription>{st.description || "Questa operazione non può essere annullata."}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" onClick={() => done(false)}>{st.cancelLabel || "Annulla"}</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-ok" onClick={() => done(true)} className={st.danger === false ? "" : "bg-red-600 hover:bg-red-700 focus:ring-red-600"}>{st.confirmLabel || "Elimina"}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
